import React, { useState } from "react";
import { Modal } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { HelixTemplate } from "./Helix";


type Props = {
  visible: boolean;
  selectedTemplate?: HelixTemplate | null;
  onSubmit: (confirm: boolean) => Promise<void> | void;
};

const DeleteHelixTemplate: React.FC<Props> = ({
  visible,
  selectedTemplate,
  onSubmit,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  return (
    <Modal
      mask={false}
      open={visible}
      title="Proceed and delete the following?"
      okText="Confirm and Delete"
      cancelText="Cancel"
      className="action-btn delete-btn"
      okType="danger"
      onCancel={async () => {
        await onSubmit(false);
      }}
      onOk={async () => {
        try {
          setConfirmLoading(true);
          await onSubmit(true);
        } catch (error) {
          console.log("Validate Failed:", error);
        } finally {
          setConfirmLoading(false);
        }
      }}
      confirmLoading={confirmLoading}
    >
      <p>
        Please confirm that you wish to delete the template: <br />
        <strong>{selectedTemplate ? `'${selectedTemplate.name}'` : ""}</strong>, this option cannot be
        undone.
      </p>
    </Modal>
  );
};

export default DeleteHelixTemplate;
